import { api } from '../../libs/api'
import { ErrorMessages } from '../../constants'

export default {
  namespaced: true,

  state: {
    detail: {},
    passwordErrors: [],
  },
  getters: {
    demo: state => state.detail.demo,
    manuscriptAi: state => state.detail.manuscript_ai,
    jobCsvDownloadLimit: state => (state.detail.large_job_csv_download_enabled ? 10000 : 1000),
    searchJobCsvDownloadEnabled: state => state.detail.search_job_csv_download_enabled === true,
  },
  mutations: {
    detail: (state, detail) => state.detail = detail,
    clear: state => state.detail = {},
    passwordErrors: (state, errors) => state.passwordErrors = errors,
    preparePasswordResetApplication: state => state.passwordErrors = [],
    preparePasswordUpdate: state => state.passwordErrors = [],
  },
  actions: {
    async set ({ commit }, { user }) {
      commit('detail', user)
    },
    async applyPasswordReset ({ commit }, { email }) {
      try {
        await api.applyPasswordReset({ email })
      } catch (e) {
        commit('passwordErrors', e)
        return Promise.reject(e)
      }

      commit('passwordErrors', [])
    },
    async updatePassword ({ commit }, { password, resetPasswordToken }) {
      try {
        await api.updatePassword({ password, resetPasswordToken })
      } catch (e) {
        commit('passwordErrors', e)
        return Promise.reject(e)
      }

      commit('passwordErrors', [])
    },
    async updateJobDisplayedColumns ({ commit, state: { detail } }, { displayedColumns }) {
      try {
        const user = Object.assign({ ...detail }, { job_displayed_columns: displayedColumns })
        await api.updateUser({ user })
        commit('detail', user)
      } catch (e) {
        return Promise.reject(e)
      }
    },
    async updateCompanyDisplayedColumns ({ commit, state: { detail } }, { displayedColumns }) {
      try {
        const user = Object.assign({ ...detail }, { company_displayed_columns: displayedColumns })
        await api.updateUser({ user })
        commit('detail', user)
      } catch (e) {
        return Promise.reject(e)
      }
    },
    async updateCorporationDisplayedColumns ({ commit, state: { detail } }, { displayedColumns }) {
      try {
        const user = Object.assign({ ...detail }, { corporation_displayed_columns: displayedColumns })
        await api.updateUser({ user })
        commit('detail', user)
      } catch (e) {
        return Promise.reject(e)
      }
    },
    async updateJobsPerPage ({ commit, state: { detail } }, { jobsPerPage }) {
      try {
        const user = Object.assign({ ...detail }, { jobs_per_page: jobsPerPage })
        await api.updateUser({ user })
        commit('detail', user)
      } catch (e) {
        return Promise.reject(e)
      }
    },
    async updateCompaniesPerPage ({ commit, state: { detail } }, { companiesPerPage }) {
      try {
        const user = Object.assign({ ...detail }, { companies_per_page: companiesPerPage })
        await api.updateUser({ user })
        commit('detail', user)
      } catch (e) {
        return Promise.reject(e)
      }
    },
    async updateCorporationsPerPage ({ commit, state: { detail } }, { corporationsPerPage }) {
      try {
        const user = Object.assign({ ...detail }, { corporations_per_page: corporationsPerPage })
        await api.updateUser({ user })
        commit('detail', user)
      } catch (e) {
        return Promise.reject(e)
      }
    },
    async checkAdmin ({ state: { detail } }) {
      if (detail.has_basic && detail.admin) {
        return Promise.resolve()
      }
      throw new Error(ErrorMessages.NOT_ADMIN_USER)
    },
    async checkHasBasic ({ state: { detail } }) {
      if (detail.has_basic) {
        return Promise.resolve()
      }
      throw new Error(ErrorMessages.HAS_BASIC_FALSE)
    },
    async checkStartingBusiness ({ state: { detail } }) {
      if (detail.has_starting_business) {
        return Promise.resolve()
      }
      throw new Error(ErrorMessages.HAS_STARTING_BUSINESS_FALSE)
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js